import React from 'react';

import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { TaxDashboardWizardNav } from './TaxDashboardWizardNav';

export const TaxDashboardWizardWrapper = ({
  children,
  continueDisabled = false,
  hideProgress = false,
  customButtons = false,
  extraNavLabel,
  onClickExtraNavOverride,
}) => {
  return (
    <TaxDashboardWizardNav disabled={continueDisabled} hideProgress={hideProgress} customButtons={customButtons} extraNavLabel={extraNavLabel} onClickExtraNavOverride={onClickExtraNavOverride}>

      {/* Title and Subtitle */}
      <FDStack direction="column" spacing={0} paddingY={4}>
        <MetaControlField attr={'subtitle'} />
        <MetaControlField attr={'title'} />
      </FDStack>

      {children}

    </TaxDashboardWizardNav>
  );
};
